import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Listing from "../../lessons/Listing";
import { pageRoutes } from "../../../routes/pageRoutes";
import Loader from "../../../components/other/Loader";
import { fetchFairyweight } from "../../../redux/action/weightAction";
import { useDispatch, useSelector } from "react-redux";

const Fairyweights = () => {
  const dispatch = useDispatch();
  const { fairyweightsList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );

  useEffect(() => {
    dispatch(fetchFairyweight());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Fairyweights"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Fairyweights",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={fairyweightsList} />

        <Footer />
      </div>
    </>
  );
};

export default Fairyweights;
